var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.85332 20.4229C0.852383 23.7837 1.73738 27.0653 3.4202 29.9577L0.692383 39.8401L10.8849 37.1884C13.704 38.7112 16.8626 39.5091 20.0724 39.5093H20.0808C30.6769 39.5093 39.3024 30.9538 39.3069 20.438C39.3089 15.3423 37.3108 10.5507 33.6805 6.94572C30.0508 3.34107 25.2235 1.35486 20.08 1.35254C9.4827 1.35254 0.857852 9.90758 0.853477 20.4229",
    fill: "url(#paint0_linear_80_647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.167188 20.4165C0.166094 23.8982 1.08281 27.2971 2.82562 30.2931L0 40.5299L10.558 37.783C13.467 39.3568 16.7423 40.1866 20.0752 40.1878H20.0837C31.06 40.1878 39.9953 31.3246 40 20.4323C40.0019 15.1536 37.9319 10.1897 34.1719 6.4556C30.4114 2.72195 25.4114 0.66428 20.0837 0.662109C9.10562 0.662109 0.171563 9.52413 0.167188 20.4165ZM6.45469 29.7771L6.06047 29.1562C4.40328 26.5416 3.52859 23.5202 3.52984 20.4178C3.53344 11.3643 10.9591 3.99854 20.09 3.99854C24.5119 4.0004 28.6675 5.71079 31.7931 8.81405C34.9186 11.9176 36.6384 16.0432 36.6373 20.4311C36.6333 29.4846 29.2075 36.8513 20.0837 36.8513H20.0772C17.1064 36.8497 14.1928 36.0581 11.6519 34.5621L11.0472 34.2063L4.78188 35.8362L6.45469 29.777V29.7771Z",
    fill: "url(#paint1_linear_80_647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1061 12.1576C14.7332 11.3355 14.3409 11.3189 13.9864 11.3045C13.6961 11.2921 13.3642 11.293 13.0326 11.293C12.7007 11.293 12.1615 11.4169 11.7057 11.9107C11.2495 12.4049 9.96387 13.5993 9.96387 16.0286C9.96387 18.4581 11.7471 20.8059 11.9957 21.1356C12.2446 21.4648 15.4384 26.6096 20.4965 28.5888C24.7003 30.2336 25.5557 29.9065 26.4681 29.824C27.3806 29.7418 29.4125 28.6299 29.827 27.4769C30.2418 26.324 30.2418 25.3358 30.1175 25.1293C29.9931 24.9235 29.6612 24.8 29.1636 24.5531C28.6657 24.3062 26.2192 23.1116 25.7631 22.9468C25.3068 22.7821 24.9751 22.7 24.6432 23.1944C24.3114 23.688 23.3584 24.8 23.0679 25.1293C22.7778 25.4593 22.4873 25.5004 21.9898 25.2534C21.4918 25.0057 19.8892 24.4849 17.9878 22.8029C16.5084 21.4941 15.5096 19.8778 15.2193 19.3834C14.929 18.8897 15.1882 18.6221 15.4378 18.3761C15.6614 18.1548 15.9356 17.7995 16.1846 17.5113C16.4328 17.2229 16.5156 17.0172 16.6815 16.6879C16.8476 16.3583 16.7645 16.0699 16.6403 15.8229C16.5156 15.5759 15.5486 13.1339 15.1061 12.1576Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_80_647",
    x1: 1931.42,
    y1: 3850.11,
    x2: 1931.42,
    y2: 1.35254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_80_647",
    x1: 2000,
    y1: 3987.44,
    x2: 2000,
    y2: 0.662109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.662109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.b127f152968104f068b06e6baf3a920b.svg";
export { ForwardRef as ReactComponent };